cv.PublicMainView = Marionette.LayoutView.extend({
  el: '#main',

  regions: {
  },

  events: {
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('PublicMainView initialized');
  },

  templateHelpers: function () {
    return {
    };
  },

  onAttach: function(){
  }
});
